import { createForm11PDF, type Form11ClientParams } from '@gng-ehs/shared';
export type { Form11ClientParams } from '@gng-ehs/shared';

export function generateForm11ClientPDF(data: Form11ClientParams): string {
  return URL.createObjectURL(createForm11PDF(data).output('blob'));
}
